import React, { Component } from 'react'
import Head from 'next/head'
import { withRouter } from 'next/router'
import { get, headers } from '../../lib/fetch'
import {
  mapFiltersFromUrl,
  generateQueryString,
  convertFilters,
} from '../../lib/filterFormatter'
import { metaTagDetails } from '../../utils/tagMetaDetails'
import { cookieValuetoJSON } from '../../lib/objectValidation'
import LayoutWithFilterAndSort from '../../components/LayoutWithFilterAndSort/LayoutWithFilterAndSort'
import { PAGE_TYPES } from '../../lib/eventTrackerFunction'
import { getActiveExperimentVariants } from '../../lib/getActiveExperimentVariants'
import { getIosSmartBannerContent } from '../../utils/getIosSmartBannerContent'
import { getUserType } from '../../utils/userType'
import { CTA_LOCATION_NAME } from '../../lib/amplitude'
import {
  encodeSlugIfExist,
  isEncodedURIComponent,
  setCtaLocationMeta,
} from '../../lib/utils'
import _get from 'lodash/get'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import {
  initDyCookies,
  initDyParams,
  setDySessionFromLayout,
} from '../../utils/DyUtils'
import { getLayoutByName } from '../../components/LoadLayout'
import {
  trackSearchCompletedEvent,
  mergedSearchPropertiesEvent,
} from '../../lib/analytics/events/searchEvents/SearchCompletedEvent'

const PRODUCT_LAYOUT_NAME = 'ProductCollection'

const getData = async (
  checkoutAddress,
  router,
  userkey,
  activeExperiments = ''
) => {
  const modifiedHeaders = headers(router)
  if (typeof window === 'undefined') {
    modifiedHeaders['user-agent'] = router?.req?.headers['user-agent']
  }
  // Calling DY for Headers
  const dyParams = initDyParams(router)
  const query = router.query
  const queryStringObject = {
    tag: isEncodedURIComponent(query.slug)
      ? query.slug
      : encodeSlugIfExist(query.slug),
    url: isEncodedURIComponent(query.slug)
      ? query.slug
      : encodeSlugIfExist(query.slug),
    layoutType: 'GRID',
    pageType: PAGE_TYPES.TAG,
    page: 1,
    storeId: (checkoutAddress && checkoutAddress.storeId) || null,
    includeTagDetails: true,
    orderType: getUserType(router) === 'B2B' ? 'B2B' : 'DELIVERY',
  }
  if (activeExperiments.length) {
    const { configuration } = getConfigFor(
      SPLIT_FEATURES.ALGOLIA_PERSONALISATION
    )
    const { personalisationSettings } = configuration
    queryStringObject.algopers = personalisationSettings
    queryStringObject.experiments = activeExperiments
  }

  if (query.filter) {
    const transferredFilter = mapFiltersFromUrl(query.filter)
    queryStringObject.filter = convertFilters(transferredFilter)
  }
  if (query.sorting) {
    queryStringObject.sorting = query.sorting
  }

  const api =
    'layout/tag/v2' + generateQueryString(queryStringObject) + dyParams
  const response = await get(api, {
    headers: {
      ...modifiedHeaders,
      'x-device-Id': userkey,
    },
  })
  return {
    data: response?.data,
  }
}
class TagDetails extends Component {
  static async getInitialProps(ctx) {
    const userkey = ctx.res
      ? _get(ctx, 'res.locals.userKey')
      : window.__NEXT_DATA__.props.userKey
    const user_type = getUserType(ctx)
    const iosSmartBannerContent = getIosSmartBannerContent(ctx)
    const checkoutAddress = cookieValuetoJSON(
      ctx,
      user_type === 'B2B' ? 'b2bCheckoutAddress' : 'checkoutAddress'
    )
    const activeExperiments = getActiveExperimentVariants() || ctx.experiments
    const response = await getData(
      checkoutAddress,
      ctx,
      userkey,
      activeExperiments
    )
    return {
      data: { data: response.data },
      iosSmartBannerContent,
      userkey,
    }
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    setDySessionFromLayout(this.props.data?.data?.page?.layouts)
    const isStoreChanged = this.state && this.state.isStoreChanged
    const data = isStoreChanged
      ? this.state.storeSpecificProduct
      : this.props.data
    const entitySlug = data?.data?.page?.entity?.slug
    const tagId = data?.data?.page.entity?.id
    setCtaLocationMeta([entitySlug, tagId])

    const layouts = this.props.data?.data?.page?.layouts || []
    const { query } = this.props.router || {}
    const SEARCH_TERM = query?.query ?? null
    const productLayout = getLayoutByName(
      layouts,
      PRODUCT_LAYOUT_NAME,
      PAGE_TYPES.TAG
    )
    const userSearchCompletedEventParams = mergedSearchPropertiesEvent(
      layouts,
      productLayout,
      SEARCH_TERM
    )

    trackSearchCompletedEvent(userSearchCompletedEventParams)
    initDyCookies()
  }

  async componentDidUpdate(prevProps) {
    const { checkoutAddress } = this.props
    if (
      prevProps.checkoutAddress &&
      (String(prevProps.checkoutAddress.storeId) !==
        String(checkoutAddress.storeId) ||
        prevProps.checkoutAddress.type !== checkoutAddress.type)
    ) {
      const activeExperiments = getActiveExperimentVariants()
      const response = await getData(
        this.props.checkoutAddress,
        this.props.router,
        this.props.userkey,
        activeExperiments
      )
      setDySessionFromLayout(response.data?.page?.layouts)
      this.setState({
        storeSpecificProduct: { data: response.data },
        isStoreChanged: true,
      })
    }

    // check for query changes to use changed data from props instead of state
    if (
      (prevProps.router.query.slug !== this.props.router.query.slug ||
        prevProps.router.query.filter !== this.props.router.query.filter ||
        prevProps.router.query.sorting !== this.props.router.query.sorting) &&
      this.state.isStoreChanged
    ) {
      this.setState({
        isStoreChanged: false,
      })
    }
  }

  render() {
    const { organizationData, categoryList, iosSmartBannerContent } = this.props
    const isStoreChanged = this.state && this.state.isStoreChanged
    const data = isStoreChanged
      ? this.state.storeSpecificProduct
      : this.props.data
    const name = data?.data?.page?.entity?.name || ''
    const layouts = data?.data?.page?.layouts || []
    const slug = this.props.router?.query?.slug || ''
    const info = metaTagDetails[slug] || {}
    const entitySlug = data?.data?.page?.entity?.slug
    const tagId = data?.data?.page.entity?.id
    const pageTitle = info.title ? info.title : `${name} | FairPrice Singapore`
    const metaInfo = info.description
      ? info.description
      : "Convenient grocery shopping at your fingertips! Shop at Singapore's largest grocery retailer with a wide range of products, price match online and in-store."
    return (
      <React.Fragment>
        <Head>
          <title>{pageTitle}</title>
          <meta
            name="description"
            key="meta_description"
            content={`${metaInfo}`}
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={pageTitle} />
          <meta property="og:site_name" content="FairPrice" />
          <meta name="apple-itunes-app" content={iosSmartBannerContent} />
        </Head>
        <LayoutWithFilterAndSort
          title={name}
          layouts={layouts}
          organizationData={organizationData}
          preLoadFirstImage={true}
          categoryList={categoryList}
          ctaLocation={{
            pageName: CTA_LOCATION_NAME.TAG,
            pageMeta: [entitySlug, tagId],
          }}
          config={{
            pageType: PAGE_TYPES.TAG,
            url: this.props.router?.query?.slug,
            loc: `ProductListing-${PAGE_TYPES.TAGS}`, // in tracking should remain PAGE_TYPES.TAGS
          }}
          except={['PWP', 'isEndlessAisle']}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(TagDetails)
